import useAppSelector from '../../../../store/hooks/useAppSelector'
import { checkoutCapacityConflictActiveOptionSelector } from '../../store/checkoutSelectors'
import { CapacityConflictOptionType } from '../../types'

import CapacityConflictChoiceStep from './CapacityConflictChoiceStep'
import CapacityConflictSelectTimeStep from './CapacityConflictSelectTimeStep'
import CapacityConflictDeleteOrderStep from './CapacityConflictDeleteOrderStep'

export default function CapacityConflictAllBlocked() {
  const activeOption = useAppSelector(
    checkoutCapacityConflictActiveOptionSelector,
  )

  switch (activeOption) {
    case CapacityConflictOptionType.ChangePickupTime:
      return <CapacityConflictSelectTimeStep />

    case CapacityConflictOptionType.DeleteOrder:
      return <CapacityConflictDeleteOrderStep />

    default:
      return <CapacityConflictChoiceStep />
  }
}
